import Vue from 'vue'
import VueRouter from 'vue-router'

import Auth from '@/views/Auth.vue'

import Home from '@/views/Home.vue'
import Dashboard from '@/views/Dashboard.vue'

// Albums
import Albums from '@/views/Albums.vue'
import AlbumList from '@/views/Album/List.vue'
import AlbumCreate from '@/views/Album/Create.vue'
import AlbumView from '@/views/Album/View.vue'

// Newsletter
import Newsletter from '@/views/Newsletter.vue'
import NewsletterList from '@/views/Newsletter/List.vue'
import NewsletterCreate from '@/views/Newsletter/Create.vue'
import NewsletterView from '@/views/Newsletter/View.vue'

// Content
import Content from '@/views/Content.vue'
import ContentList from '@/views/Content/List.vue'
import ContentView from '@/views/Content/View.vue'

// Page
import Pages from '@/views/Pages.vue'
import PageList from '@/views/Page/List.vue'
import PageCreate from '@/views/Page/Create.vue'
import PageView from '@/views/Page/View.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children:[
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
      },
      {
        path: 'albums',
        name: 'Albums',
        component: Albums,
        children: [
          {
            path: '',
            name: 'AlbumList',
            component: AlbumList,
          },
          {
            path: 'create',
            name: 'AlbumCreate',
            component: AlbumCreate,
          },
          {
            path: 'view',
            name: 'AlbumView',
            component: AlbumView,
          },
        ]
      },
      {
        path: 'newsletter',
        name: 'newsletter',
        component: Newsletter,
        children: [
          {
            path: '',
            name: 'NewsletterList',
            component: NewsletterList,
          },
          {
            path: 'create',
            name: 'NewsletterCreate',
            component: NewsletterCreate,
          },
          {
            path: 'view',
            name: 'NewsletterView',
            component: NewsletterView,
          },
        ]
      },
      {
        path: 'content',
        name: 'content',
        component: Content,
        children: [
          {
            path: '',
            name: 'ContentList',
            component: ContentList,
          },
          {
            path: 'view',
            name: 'ContentView',
            component: ContentView,
          },
        ]
      },
      {
        path: 'pages',
        name: 'Pages',
        component: Pages,
        children: [
          {
            path: '',
            name: 'PageList',
            component: PageList,
          },
          {
            path: 'create',
            name: 'PageCreate',
            component: PageCreate,
          },
          {
            path: 'view',
            name: 'PageView',
            component: PageView,
          },
        ]
      },
    ]
  },
  {
    path: '/auth',
    name: 'Auth',
    component: Auth
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let isAuthenticated = localStorage.getItem('user-token') != null

  if (to.name !== 'Auth' && !isAuthenticated){
    next({ name: 'Auth' })
  } else {
    next()
  }
})

export default router
